import * as React from "react";
import {
  Autocomplete,
  Avatar,
  Button,
  Chip,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import style from "../../Styles/vehicleInfo.module.css";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

import Grid from "@mui/material/Grid";

import { urlEnum } from "../../Utils/urlEnum";

import { isMobile } from "../../Utils/utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import { getData } from "../../Services/getData";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { updateData } from "../../Services/updateData";
import { CacheContext } from "../../Context/cacheContext";
import {
  DEFAULT_MAX_NUMBER_OF_MESSAGES,
  RolesEnum,
  tipStatusVehicule,
} from "../../Utils/Constants";
import { clientMessagesType } from "../../Utils/autocompleteEnum";
import GenericAutocompleteModal from "../../Modal/GenericAutocompleteModal";
import TrimesterSyncDialog from "../Users/TrimesterSyncDialog";
import * as yup from "yup";
import { uploadEntityLogo } from "../../Utils/logoUploadHelper";

// import { getBnr } from "../../Services/getBnr";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function PlatformSettings() {
  const cacheContext = React.useContext(CacheContext);
  const [openLocationModal, setOpenLocationModal] = React.useState(false);
  const [requireNrInmatriculareDialogOpen, setRequireNrInmatriculareDialogOpen] = React.useState(false);
  const [pendingRequireNrInmatriculareValue, setPendingRequireNrInmatriculareValue] = React.useState(false);
  const [editedLocation, setEditedLocation] = React.useState({
    nume: "",
    adresa: "",
    judet: "",
    telefon: "",
  });

  const [state, setState] = React.useState({
    telefonContactAnunturiPDF: "",
    ProcentDobanda: "",
    MaxNotificariDrawer: "",
    DeadlineRaportari: "",
    IDStatusVandut: "",
    procentTVA: 19,
    automatedClientMessages: "0",
    requireNrInmatriculareForComision: false,
    maxNumberForMessages: DEFAULT_MAX_NUMBER_OF_MESSAGES,
    usersForClientMessages: [],
    usersForFinancingRequests: [],
    usersForOnDemandsCars: [],
  });
  const cacheData = cacheContext.cache;

  const locationValidationSchema = yup.object({
    nume: yup.string().required(Vocabulary.requiredField),
    adresa: yup.string(),
    judet: yup.string(),
    telefon: yup.string(),
  });
  const roles = localStorage?.roles || "";
  const permissions = localStorage?.permissions || "";
  const canCreateApplication =
    roles.includes(RolesEnum.admin) ||
    permissions.includes("createNewApplication");

  const handleLocationLogo = async (file, locationData) => {
    await uploadEntityLogo(
      file,
      locationData,
      urlEnum.locatie_administrativa_r,
    );

    setOpenLocationModal(false);
  };

  const locationColumns = [
    {
      label: Vocabulary.id,
      name: "id",
      options: {
        sort: false,
        display: false,
      },
    },
    {
      label: `${Vocabulary.name}`,
      name: "nume",
      options: {
        sort: false,
      },
    },
    {
      label: "Adresa",
      name: "adresa",
      options: {
        sort: false,
      },
    },
    {
      label: "Judet",
      name: "judet",
      options: {
        sort: false,
      },
    },
    {
      label: "Telefon",
      name: "telefon",
      options: {
        sort: false,
      },
    },
    {
      name: "active",
      label: Vocabulary.active,
      options: {
        filter: true,
        sort: false,
        type: "boolean",
        customBodyRender: (value) => {
          return <Switch checked={Boolean(value)} disabled />;
        },
      },
    },
    {
      name: "logo",
      label: "Logo",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Button
                color="primary"
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                size="small"
                startIcon={<CloudUploadIcon />}
              >
                {Vocabulary.upload}
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) =>
                    handleLocationLogo(
                      event.target.files[0],
                      cacheData?.locations[tableMeta.rowIndex],
                    )
                  }
                  accept="image/png, image/jpg, image/jpeg"
                />
              </Button>

              {value ? (
                <img
                  src={`/api/${value}`}
                  width={100}
                  alt="Logo"
                  style={{
                    padding: "4px",
                  }}
                />
              ) : null}
            </div>
          );
        },
      },
    },
  ];

  /**
   * Get status
   */
  React.useEffect(() => {
    getSettings();
  }, []);

  /**
   *
   * @param page
   * @param perPage
   * @param search
   */
  async function getSettings() {
    let url = `${urlEnum.settings}`;
    const settings = await getData(url);
    setState({
      ...state,
      telefonContactAnunturiPDF: settings.data.data.telefonContactAnunturiPDF,
      ProcentDobanda: settings.data.data.ProcentDobanda,
      MaxNotificariDrawer: settings.data.data.MaxNotificariDrawer,
      DeadlineRaportari: settings.data.data.DeadlineRaportari,
      IDStatusVandut: settings.data.data.IDStatusVandut,
      procentTVA: settings.data.data.procentTVA,
      automatedClientMessages: settings.data.data.automatedClientMessages,
      requireNrInmatriculareForComision:
        settings.data.data.requireNrInmatriculareForComision ?? false,
      usersForClientMessages: settings.data.data.usersForClientMessages,
      usersForFinancingRequests: settings.data.data.usersForFinancingRequests,
      usersForOnDemandsCars: settings.data.data.usersForOnDemandsCars,
      maxNumberForMessages: settings.data.data.maxNumberForMessages,
    });
  }

  /*FUNCTION THAT FETCH DATA ABOUT UNREAD MEASSAGES BASED ON IDS */
  /**
   *
   * @param {*} index => userId
   * @param {*} type => type of client message
   * @returns
   */
  async function getUnreadMessages(index, type) {
    let url = `${urlEnum.unreadMessages}/${index}/${type}`;
    const settings = await getData(url);
    return settings?.data?.unreadMessagesCount;
  }

  /**
   * refreshes the cache data with the new values
   * @param data
   */
  const refreshCache = (data) => {
    const id = Object.keys(data.data);
    const tempLocalStorage = Object.assign({}, cacheData);
    id.forEach((element) => {
      if (cacheData[element]) tempLocalStorage[element] = data.data[element];
    });
    cacheContext.setCache(tempLocalStorage);
  };

  /**
   *
   * @returns
   */
  async function updateSettings() {
    let url = `${urlEnum.settings}`;

    const idsForUsersMessages = Object.assign({}, state);
    idsForUsersMessages.usersForClientMessages =
      state.usersForClientMessages?.map((item) => item.id);

    idsForUsersMessages.usersForFinancingRequests =
      state.usersForFinancingRequests?.map((item) => item.id);

    idsForUsersMessages.usersForOnDemandsCars =
      state?.usersForOnDemandsCars?.map((item) => item.id);

    const res = await updateData(url, idsForUsersMessages);
    if (!res || res?.error) {
      return;
    }
    setState({
      ...state,
      data: res.data.data,
    });
    refreshCache(res);
    getSettings();
  }

  /**
   *
   * @param {*} event
   */
  function handleChangeTextFields(event) {
    const newObj = Object.assign({}, state);
    newObj[event.target.name] = event.target.value;
    setState(newObj);
  }

  /**
   *
   * @param {*} event
   */
  function handleChangeSwitch(event) {
    const newObj = Object.assign({}, state);
    newObj.automatedClientMessages = event.target.checked ? 1 : 0;
    setState(newObj);
  }

  function handleChangeRequireNrInmatriculare(event) {
    setPendingRequireNrInmatriculareValue(event.target.checked);
    setRequireNrInmatriculareDialogOpen(true);
  }

  async function handleConfirmRequireNrInmatriculare(months) {
    const res = await updateData(urlEnum.settings, {
      requireNrInmatriculareForComision: pendingRequireNrInmatriculareValue,
      trimester_sync_months: months,
    });
    if (!res || res?.error) return;

    setState((prev) => ({
      ...prev,
      requireNrInmatriculareForComision: pendingRequireNrInmatriculareValue,
    }));
    setRequireNrInmatriculareDialogOpen(false);
  }

  return (
    <Paper
      style={{
        padding: 15,
        marginBottom: 35,
        borderRadius: "0px 0px 15px 15px ",
      }}
    >
      <ValidatorForm
        method="get"
        onSubmit={updateSettings}
        id="settingsPlatform"
        style={{ marginTop: 10 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            flexDirection: isMobile() ? "column" : "row",
          }}
        >
          <Grid
            container
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            xl={12}
            //md={12}
            sx={12}
          >
            <Grid item={4} xl={4} xs={12} gap={2}>
              <TextValidator
                name="telefonContactAnunturiPDF"
                InputLabelProps={{
                  shrink: true,
                }}
                className={style.textValidator}
                label={Vocabulary.nrTelefonPdf}
                fullWidth
                errorMessages={[Vocabulary.requiredField]}
                value={state?.telefonContactAnunturiPDF}
                onChange={handleChangeTextFields}
              />
              <TextValidator
                type="number"
                name="ProcentDobanda"
                InputLabelProps={{
                  shrink: true,
                }}
                className={style.textValidator}
                label={Vocabulary.procentDobanda}
                fullWidth
                errorMessages={[Vocabulary.requiredField]}
                value={state?.ProcentDobanda}
                onChange={handleChangeTextFields}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditedLocation(null);
                  setOpenLocationModal(true);
                }}
                style={{ marginTop: 20, width: "100%" }}
              >
                {Vocabulary.manageLocations}
              </Button>
              {canCreateApplication && (
                <Button
                  variant="contained"
                  onClick={() => {
                    window.open(process.env.REACT_APP_REGISTER_URL || "https://register.erp.xauto.ro", "_blank");
                  }}
                  style={{
                    marginTop: 20,
                    width: "100%",
                    backgroundColor: "#FF6633",
                    color: "#fff",
                  }}
                >
                  {Vocabulary.createNewApplication}
                </Button>
              )}
            </Grid>
            <Grid item={4} xl={4} xs={12} gap={2}>
              <TextValidator
                name="IDStatusVandut"
                className={style.textValidator}
                InputLabelProps={{
                  shrink: true,
                }}
                label={Vocabulary.idStatusVandut}
                fullWidth
                errorMessages={[Vocabulary.requiredField]}
                value={state?.IDStatusVandut}
                onChange={handleChangeTextFields}
              />
              <TextValidator
                type="number"
                name="DeadlineRaportari"
                className={style.textValidator}
                InputLabelProps={{
                  shrink: true,
                }}
                label={Vocabulary.deadlineRaportari}
                fullWidth
                errorMessages={[Vocabulary.requiredField]}
                value={state?.DeadlineRaportari}
                onChange={handleChangeTextFields}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 10,
                  width: "100%",
                }}
              >
                <Typography
                  style={{ margin: 10, marginLeft: 17, fontSize: 15 }}
                >
                  {Vocabulary.requireNrInmatriculareForComision}
                </Typography>
                <Switch
                  checked={Boolean(state.requireNrInmatriculareForComision)}
                  name="requireNrInmatriculareForComision"
                  id="requireNrInmatriculareForComision"
                  onChange={handleChangeRequireNrInmatriculare}
                />
              </div>
            </Grid>
            <Grid item={4} xl={4} xs={12} gap={2}>
              <TextValidator
                type="number"
                name="MaxNotificariDrawer"
                className={style.textValidator}
                InputLabelProps={{
                  shrink: true,
                }}
                label={Vocabulary.nrMaximNotificari}
                fullWidth
                errorMessages={[Vocabulary.requiredField]}
                value={state?.MaxNotificariDrawer}
                onChange={handleChangeTextFields}
              />
              <div>
                <TextValidator
                  type="number"
                  name="procentTVA"
                  className={style.textValidator}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label={Vocabulary.VATPercent}
                  fullWidth
                  value={state.procentTVA}
                  errorMessages={[Vocabulary.requiredField]}
                  onChange={handleChangeTextFields}
                />
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 10,
                    width: "100%",
                  }}
                >
                  <Typography
                    style={{ margin: 10, marginLeft: 17, fontSize: 15 }}
                  >
                    {Vocabulary.automatedClientMessage}
                  </Typography>

                  <Switch
                    checked={state.automatedClientMessages === 1 ? true : false}
                    name="clientMessagesSettings"
                    id="clientMessagesSettings"
                    onChange={handleChangeSwitch}
                  />
                </div>
                <Autocomplete
                  freeSolo={false}
                  multiple
                  id="usersForClientMessages"
                  disablePortal
                  disableClearable
                  className={style.textValidator}
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  disabled={state.automatedClientMessages === 1 ? false : true}
                  value={
                    state?.usersForClientMessages?.length
                      ? state?.usersForClientMessages
                      : []
                  }
                  fullWidth
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.nume}
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor:
                                state.maxNumberForMessages <=
                                option.unreadMessagesCount
                                  ? "#F0B3B3"
                                  : "#CAE8B7",
                            }}
                          >
                            {option.unreadMessagesCount
                              ? option.unreadMessagesCount
                              : 0}
                          </Avatar>
                        }
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  onChange={async (_event, value) => {
                    if (value?.length)
                      value[value.length - 1].unreadMessagesCount =
                        await getUnreadMessages(
                          value[value.length - 1]?.id,
                          clientMessagesType.contactMessage,
                        ); //TO DO : SCHIMBA DIN ENUM

                    setState({ ...state, usersForClientMessages: value });
                  }}
                  getOptionLabel={(option) => option?.nume}
                  options={cacheContext.cache.users}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{ marginTop: 10 }}
                      id="usersForClientMessages"
                      label={Vocabulary.usersForClientMessages}
                      name="usersForClientMessages"
                    />
                  )}
                />
                <Autocomplete
                  freeSolo={false}
                  multiple
                  id="usersForFinancingRequests"
                  fullWidth
                  disableClearable
                  disabled={state.automatedClientMessages === 1 ? false : true}
                  className={style.textValidator}
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  onChange={async (_event, value) => {
                    if (value?.length)
                      value[value.length - 1].unreadMessagesCount =
                        await getUnreadMessages(
                          value[value.length - 1]?.id,
                          clientMessagesType.financingRequest,
                        ); //TO DO : SCHIMBA DIN ENUM

                    setState({ ...state, usersForFinancingRequests: value });
                  }}
                  value={
                    state?.usersForFinancingRequests?.length
                      ? state?.usersForFinancingRequests
                      : []
                  }
                  getOptionLabel={(option) => option?.nume}
                  options={cacheContext.cache.users}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.nume}
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor:
                                state.maxNumberForMessages <=
                                option.unreadMessagesCount
                                  ? "#F0B3B3"
                                  : "#CAE8B7",
                            }}
                          >
                            {option.unreadMessagesCount
                              ? option.unreadMessagesCount
                              : 0}
                          </Avatar>
                        }
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{ marginTop: 10 }}
                      id="usersForFinancingRequests"
                      label={Vocabulary.usersForFinancingRequests}
                      name="usersForFinancingRequests"
                    />
                  )}
                />
                <Autocomplete
                  freeSolo={false}
                  multiple
                  id="usersForOnDemandsCars"
                  className={style.textValidator}
                  disableClearable
                  fullWidth
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  disabled={state.automatedClientMessages === 1 ? false : true}
                  onChange={async (event, value) => {
                    if (value?.length)
                      value[value.length - 1].unreadMessagesCount =
                        await getUnreadMessages(
                          value[value.length - 1]?.id,
                          tipStatusVehicule.CarOrder,
                        ); //TO DO : SCHIMBA DIN ENUM

                    setState({ ...state, usersForOnDemandsCars: value });
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.nume}
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor:
                                state.maxNumberForMessages <=
                                option.unreadMessagesCount
                                  ? "#F0B3B3"
                                  : "#CAE8B7",
                            }}
                          >
                            {option.unreadMessagesCount}
                          </Avatar>
                        }
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  value={
                    state?.usersForOnDemandsCars?.length
                      ? state?.usersForOnDemandsCars
                      : []
                  }
                  getOptionLabel={(option) => option?.nume}
                  options={cacheContext.cache.users}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{ marginTop: 10 }}
                      id="usersForOnDemandsCars"
                      label={Vocabulary.usersForOnDemandsCars}
                      name="usersForOnDemandsCars"
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </ValidatorForm>
      <TrimesterSyncDialog
        open={requireNrInmatriculareDialogOpen}
        onClose={() => setRequireNrInmatriculareDialogOpen(false)}
        onConfirm={handleConfirmRequireNrInmatriculare}
        title={Vocabulary.requireNrInmatriculareForComisionDialogTitle}
        description={Vocabulary.requireNrInmatriculareForComisionDialogDescription}
        confirmLabel={Vocabulary.requireNrInmatriculareForComisionConfirm}
        optionDescriptions={{
          current_month:
            Vocabulary.requireNrInmatriculareForComisionCurrentMonthDescription,
          current_and_past:
            Vocabulary.requireNrInmatriculareForComisionCurrentAndPastDescription,
        }}
        optionWarnings={{
          current_and_past:
            Vocabulary.requireNrInmatriculareForComisionWarningPast,
        }}
      />
      <GenericAutocompleteModal
        open={openLocationModal}
        width={1000}
        onClose={() => {
          setOpenLocationModal(false);
          setEditedLocation({
            nume: "",
            adresa: "",
            judet: "",
            telefon: "",
            active: null,
          });
        }}
        title={Vocabulary.locations}
        data={cacheData?.locations || []}
        id="locatie_administrativa_r"
        columns={locationColumns}
        validationSchema={locationValidationSchema}
        hiddenFieldsArray={["id", "logo"]}
        modelForFields={
          editedLocation
            ? { ...editedLocation }
            : {
                nume: "",
                adresa: "",
                judet: "",
                telefon: "",
                active: true,
              }
        }
        onEdit={(_value, tableMeta) => {
          // Convert array of values to object with column names as keys
          const rowData = tableMeta.tableData[tableMeta.rowIndex];
          const locationObject = {
            id: rowData[0], // ID is the first column
          };

          locationColumns?.forEach((col, index) => {
            locationObject[col.name] = rowData[index];
          });

          setEditedLocation(locationObject);
        }}
        onSucces={() => {
          setOpenLocationModal(false);
          setEditedLocation({
            nume: "",
            adresa: "",
            judet: "",
            telefon: "",
            active: null,
          });
        }}
      />
    </Paper>
  );
}
